import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { OrdemProducaoOutrosEstabComponent } from './ordem-producao-outros-estab.component';
import { OrdemProducaoOutrosEstabEditComponent } from './ordem-producao-outros-estab-edit/ordem-producao-outros-estab-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [OrdemProducaoOutrosEstabComponent, OrdemProducaoOutrosEstabEditComponent]
})
export class OrdemProducaoOutrosEstabModule { }
